const device = new DeviceComponent({
	deviceType: 'apple-iphone-x-space-gray'
});

device.setupContext();

export default device;
